module.exports = __webpack_public_path__ + "img/j_4.705935af.jpg";